import {
  listVersions,
  getVersion,
  createVersion,
  updateVersion,
  deleteVersion,
  importVersion,
  exportVersion
} from "@/apis/versionSettings";

const handleResponse = (response) => {
  if (response?.status?.toLowerCase() === "error") {
    throw new Error(response.error || response.message);
  } else {
    return response.value;
  }
};


export const VersionSettingsDataProvider = {
  getList: async ({ resource, pagination, filters, sorters, meta }) => {
    const response = await listVersions();
    const data = response.value;
    return {
      data,
      total: data.length,
    };
  },
  getOne: async ({ id, meta }) => {
    if (!id) {
      return null;
    }
    
    const resp = await getVersion(id);
    return resp.value;
    
  },
  create: async ({variables, meta }) => {
    const result = await createVersion(variables);
    return { result };
  },
  update: async ({ id, variables }) => {
    const resp = await updateVersion(id, variables);
    return handleResponse(resp);
  },
  deleteOne: async ({ resource, id }) => {
    const resp = await deleteVersion(id);
    return resp.value;
  },
  getApiUrl: () => {
    throw new Error("Function not implemented.");
  },
};
